<template lang="html">
  <keep-alive>
    <div>
      <Header :showInfo="showinfo" :showSearchIcon="false" />
      <ComHeader type="4" :title="'详情页'" />
      <div style="height: .55rem;"></div>
      <DataPanel />
      <KuaishouTextAd />
      <ExpressNews />
      <MainChart :defaultTab="defaultTab"/>
      <Tabs v-if="canload" />
      <div
        v-if="!isKuaishouSearch"
        style="position:fixed;bottom:0;width:100%;z-index:997;background:#fff;box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);">
        <Logo @openAppStore="openAppStore" />
      </div>
    </div>
  </keep-alive>
</template>

<script>
import Header from "./Header/index.vue";
import DataPanel from "./DataPanel/index.vue";
import ExpressNews from "./ExpressNews/index.vue";
import MainChart from "./MainChart/index.vue";
import Logo from "./Logo/index.vue";
import Tabs from "./Tabs/index.vue";
import { request } from "@/api/request";
import { mapState, mapMutations } from "vuex";
import OpenModal from "@/utils/modal";
import ScTrack from '@/utils/track'

import ComHeader from "@/components/common/comHeader.vue";
import KuaishouTextAd from '@/components/common/KuaishouTextAd.vue';
import { isKuaishouSearch, getKuaishouQuery } from '@/utils/kuaishouQuery';

export default {
  components: {
    Header,
    DataPanel,
    ExpressNews,
    MainChart,
    Logo,
    Tabs,
    ComHeader,
    KuaishouTextAd,
  },
  data() {
    return {
      refreshKeepAlive: true, // 用户局部刷新keep-alive组件
      showinfo: false,
      canload: false,
      iscre: false,
      toTop: this.$route.query.toTop || 0,
      defaultTab: 'MIN1',
      isKuaishouSearch: false,
    };
  },
  computed: {
    ...mapState(["homeScrollTop", "dyna"]),
  },
  async created() {
    this.loadScript()
    const ksQuery = getKuaishouQuery(this.$route.query)
    if (isKuaishouSearch(this.$route.query)) {
      this.isKuaishouSearch = true
      const typeMap = {
        '0': 'MIN1',
        '1': '5-MIN1',
        '2': 'DAY',
        '3': 'WEEK',
        '4': 'MONTH'
      }
      this.defaultTab = typeMap[ksQuery.period] || 'MIN1'
    }
    this.iscre = true;
    await this.createInit();
    this.$router.options.routes.filter(
      (_) => _.name === "Home"
    )[0].meta.keepAlive = true;
    this.iscre = false;
  },
  async activated() {
    // setTimeout(() => {
    //     console.log(this.dyna, '=======dyna')
    // }, 2000)
    const { refreshKeepAlive = false } = this.$route.query;
    // if (refreshKeepAlive) this.refreshKeepAlive = true
    this.refreshKeepAlive = true;
    if (!this.iscre) {
      this.toTop = this.$route.query.toTop || 0;
      await this.createInit();
    }
    this.canload = true
    console.log('canload==激活',this.canload)
  },
  deactivated() {
    const { refreshKeepAlive = false } = this.$route.query;
    // if (refreshKeepAlive) this.refreshKeepAlive = false
    this.refreshKeepAlive = false;
    this.canload = false
    console.log('canload==非激活',this.canload)
  },
  methods: {
    ...mapMutations(["setHomeScrollTop"]),
    async createInit() {
      if (this.$route.params.code)
        this.$store.commit("setSymbol", this.$route.params);
      else this.$store.commit("setSymbol", this.$route.query);
      let stockname = await this.getStockName();
      this.$store.commit("setStockName", stockname);
      this.canload = true;
      // this.toTop = this.$route.query.toTop || 0
      this.scrollAddListen();
    },
    scrollAddListen() {
      window.onscroll = null;
      window.onscroll = () => {
        this.setHomeScrollTop(window.scrollY);
        if (window.scrollY > 30) {
          this.showinfo = true;
        } else this.showinfo = false;
      };
      window.scrollTo(0, this.toTop);
    },
    /**
     * 获取个股名称
     */
    async getStockName() {
      if (this.$store.state.market.toLowerCase() === 'bj') {
        const res = await request._get(request.apis.quote.getHandicap, {
          market: 'bj',
          symbol: this.$store.state.code,
        }, true);
        return res && res.prodName || ''
      }
      function marketTransform(val) {
        let keytmar = {
          NASDAQ: "NASDAQ",
          nasdaq: "NASDAQ",
          NA: "NASDAQ",
          sh: "sh",
          SH: "sh",
          sz: "sz",
          SZ: "sz",
          HK: "HKSE",
          hk: "HKSE",
          hkse: "HKSE",
          AMEX: "AMEX",
          amex: "amex",
          AM: "AMEX",
          am: "AMEX",
          HKIDX: "HKIDX",
          hkidx: "HKIDX",
        };
        return keytmar[val] || val;
      }
      let market = marketTransform(this.$store.state.market);
      let symbol = this.$store.state.code;
      if (this.$store.state.isIndex && this.$store.state.region === "CN")
        market = market.toLowerCase();
      if (this.$store.state.region === "HK") {
        symbol =
          symbol.length === 4 && /\d+/.test(symbol) ? "0" + symbol : symbol;
      }
      let res = await request.get({
        url: request.apis.quote.getStockName,
        params: {
          symbol,
          market,
          keyword: this.$store.state.code,
        },
      });

      if (res && res.length > 0) {
        return res[0].Name;
      }
    },
    openAppStore() {
      try {
        ScTrack && ScTrack.getInstance().track('click_download_floating_layer', {
          source: 'enter_mobile_stock_page'
        })
      } catch (e) {
        console.log(e)
      }
      window.open(`https://h5.chongnengjihua.com/rjhy/activity-h5/x-jfql-weichat.html?t=operation&c=o_d_o_ydgw1208`);
    },
    async loadScript() {
      const tracker = ScTrack.getInstance()
      await tracker.loadSdk()
      tracker.track('enter_mobile_stock_page')
    }
  },
};
</script>
